//export const isMobile =  false;///Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
var orientationChange = false;
export const isMobile = window.innerHeight > window.innerWidth || orientationChange;

export const itectorVisible = window.innerHeight > 1135 && window.innerWidth > 600;
export const contokVisible = window.innerHeight > 1050 && window.innerWidth > 685;
// export const isMobile = true